import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'dayNameToShort'
})
export class DayNameToShortPipe implements PipeTransform {
	transform(value: string | number): string {
		if (value === undefined || value === null || value === '') return '';

		const dayMapping: { [key: string]: string } = {
			Monday: 'Mon',
			Tuesday: 'Tue',
			Wednesday: 'Wed',
			Thursday: 'Thu',
			Friday: 'Fri',
			Saturday: 'Sat',
			Sunday: 'Sun'
		};

		const dayIndexMapping: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		if (typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 6) {
			return dayIndexMapping[value];
		}

		return dayMapping[value] || value.toString();
	}
}
